import React, { ComponentType } from 'react'
import {
  Container,
  Grid,
  Segment
} from 'semantic-ui-react'
// Local
import SubHeader from '../common/SubHeader'
import DailyProductivityCount from './dailyProductivityCount'
import TotalReviewCount from './totalReviewCount'

const SafeSegment = Segment as unknown as ComponentType<any>
const SafeGrid = Grid as unknown as ComponentType<any>

function Report() {

  return (
    <div className="header-padding">
      <Container>
        <SubHeader left="Reports" />
        <SafeSegment
          attached
          className="no-margin"
        >
          <SafeGrid>
            <Grid.Row>
              <Grid.Column
                mobile={ 16 }
                tablet={ 16 }
                computer={ 16 }
              >
                <TotalReviewCount />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column
                mobile={ 16 }
                tablet={ 16 }
                computer={ 16 }
              >
                <DailyProductivityCount />
              </Grid.Column>
            </Grid.Row>
          </SafeGrid>
        </SafeSegment>
      </Container>
    </div>
  )
}

export default Report
